module.exports = __webpack_public_path__ + "img/7.93acc558.png";